import React from "react";
import { Paper, Stack } from "@mantine/core";

export const WidgetWrapper = ({ px, children, ...rest }) => {
  return (
    <Paper py="md" px={px || "md"} {...rest}>
      <Stack gap="md" style={{ height: "100%" }}>
        {children}
      </Stack>
    </Paper>
  );
};
